import React, { useState } from 'react';

// "Where to pay" — UPI ONLY. Shows the healer's UPI id in full. Bank details are never fetched or shown;
// the summary row only says whether bank details exist (hasBankDetails).
const PayeeUpiPanel = ({ upiId, hasBankDetails }) => {
  const [copied, setCopied] = useState(false);

  const copy = function() {
    try {
      navigator.clipboard.writeText(upiId).then(function() { setCopied(true); });
    } catch (e) { /* clipboard unavailable — the id is still visible to type */ }
  };

  const box = { background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: '10px 12px', fontSize: 13, color: '#374151', margin: '12px 0' };
  return (
    <div style={box}>
      <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Where to pay</div>
      {upiId ? (
        <span>UPI id: <strong>{upiId}</strong>{' '}
          <button onClick={copy} style={{ marginLeft: 6, padding: '2px 8px', fontSize: 12, border: '1px solid #d1d5db', borderRadius: 4, background: '#fff', cursor: 'pointer' }}>
            {copied ? 'Copied' : 'Copy'}
          </button>
        </span>
      ) : hasBankDetails ? (
        'Bank details on file. Ask the healer to add a UPI id.'
      ) : (
        'No UPI id on file. Ask the healer to add one.'
      )}
    </div>
  );
};

export default PayeeUpiPanel;
